export function canPauseQualityItem(qualityCheckName: string, status: string): boolean {
  if (qualityCheckName !== "HSAID/SITHS") {
    return false;
  }

  if (!status) {
    return false;
  }

  return ["Approved", "ApprovedWithComment"].includes(status);
}
